export enum TransactionStatus {
    New = 0,
    InProgress = 1,
    Failed = 2,
    Successful = 3,
    Abandoned = 4,
    Retried = 5,
    Deleted = 6,
}

export enum ReviewTransactionStatus {
    Failed = 2,
    Abandoned = 4,
}

export enum ReviewStatus {
    None = 0,
    InReview = 1,
    Verified = 2,
    Retried = 3,
}

export enum PriorityType {
    High = 0,
    Normal = 1,
    Low = 2,
}

export enum ProcessingExceptionType {
    ApplicationException = 0,
    BusinessException = 1,
}

export interface ITransaction {
    id: number;
    name: string;
    itemsToProcess: number;
    avgTime: number;
    description: string;
    acceptAutoRetry: boolean;
    maxNoOfRetries: number;
    enforceUniqueReference: boolean;
    itemsInProgress: number;
    successfulTransactions: number;
    applicationExceptions: number;
    businessExceptions: number;
    processName?: string;
    triggerId: number | null;
    specificDataJsonSchemaExists: boolean;
    outputDataJsonSchemaExists: boolean;
    analyticsDataJsonSchemaExists: boolean;
}

export interface ITransactionStat {
    id: number;
    processingTime?: Date;
    reportType: string;
    applicationExceptionNo: number;
    businessExceptionNo: number;
    successNo: number;
    retriedItems: number;
    appExProcTime?: number;
    businessExProcTime: number;
    successProcTime: number;
}
